<template>
    <ul id="pages-menu">
        <!-- Pages List -->
        <li class="pages-list" v-for="(item, index) in pages" :key="index">
            <!-- Set the routers -->
            <router-link
                class="page-link"
                active-class="active"
                :to="{name: item.name}"
            >
                {{item.name}}
                <div class="page-bar"></div>
            </router-link>
        </li>
    </ul>
</template>

<script>
export default {
    name:'PagesMenu',
    data() {
        return {
            pages: this.$router.options.routes  // get all pages (page-routers)
        }
    },
}
</script>

<style scoped>
#pages-menu{
    display: inline-block;
    width: fit-content;
}

/* pages-list Position */
.pages-list{
    display: inline-block;
    margin: 0 40px;
}

/* page-link styles */
.page-link{
    display: block;
    position: relative;
    line-height: 50px;
    font-size: 20px;
    text-decoration: none;
    color: aliceblue;
}

/* page-bar styles */
.page-bar{
    width: 0;
    height: 2px;
    position: absolute;
    bottom: 13px;
    background-color: rgb(207, 207, 20);
    transition: width 0.3s;
}

/* activated and hover page-bar's styles */
.active > .page-bar,
.page-link:hover > .page-bar{
    width: 100%;
}
</style>